"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Columns component.
 *
 * This is the container for the columns, or in terms of HTML, it is the
 * wrapping `<ul>` element. You specify a list of `ColumnItem` components as
 * the children, and it will flow them into the correct columns based on the
 * props passed in.
 *
 * @class Columns
 * @public
 */
class Columns extends _react.Component {
  /**
   * Create the columns in a horizontal direction for the supplied items.
   *
   * @param {Array} items items to render into columns
   * @param {Number} num the number of columns to make
   * @returns {Array} columns
   * @api private
   */
  horizontal(items, num) {
    const columns = [];
    let i;
    for (i = 0; i < num; i++) {
      columns[i] = [];
    }
    for (i = 0; i < items.length; i++) {
      columns[i % num].push(items[i]);
    }
    return columns;
  }

  /**
   * Create the columns in a vertical direction for the supplied items.
   *
   * @param {Array} items items to render into columns
   * @param {Number} num the number of columns to make
   * @returns {Array} columns
   * @api private
   */
  vertical(items, num) {
    const itemsPerColumn = Math.ceil(items.length / num);
    const columns = [];
    let i;
    for (i = 0; i < num; i++) {
      const start = i * itemsPerColumn;
      const end = start + itemsPerColumn;
      columns[i] = items.slice(start, end);
    }
    return columns;
  }

  /**
   * Render the component.
   *
   * @returns {ReactElement} div
   * @api public
   */
  render() {
    const props = _objectSpread({
      num: 4,
      style: 'vertical'
    }, this.props);
    const {
      num,
      style
    } = props;
    const children = _react.default.Children.toArray(props.children);
    const className = (0, _classnames.default)('column', props.className);
    const columns = this[style](children, num);
    if (!columns || columns.length === 0) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "column-layout",
      style: {
        '--cols': num
      }
    }, columns.map((items, idx) => {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: className,
        key: idx
      }, items);
    }));
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
Columns.propTypes = {
  num: _propTypes.default.number,
  style: _propTypes.default.oneOf(['horizontal', 'vertical']),
  className: _propTypes.default.string,
  children: _propTypes.default.arrayOf(_propTypes.default.node)
};
var _default = Columns;
exports.default = _default;